export const ENVIRONMENT_MODES = {
	DEVELOPMENT: "development",
	PRODUCTION: "production",
};
